import {
    BANNER_HEIGHT_DESKTOP,
    BANNER_HEIGHT_MOBILE,
    TERMS_BLOCK_HEIGHT,
    TERMS_BLOCK_HEIGHT_MOBILE
} from '@interlayer/js/app/components/main/FeaturedBanner/constants';
import {
    TCalculateBannerHeightProps,
    TCalculatedHeight,
    TGetBannerHeightProps } from '@interlayer/js/app/components/main/FeaturedBanner/types';
import { useInDesktop, useInMobile, useInTablet } from '@interlayer/js/app/hooks/device/hooks/useMediaQuery';

const getBannerHeight = ({ customHeight, isMobile, isTablet }: TGetBannerHeightProps) => {
    if (isMobile) {
        return {
            height: Number(customHeight.mobile) ? `${customHeight.mobile}px` : BANNER_HEIGHT_MOBILE,
            isCustomHeight: Boolean(Number(customHeight.mobile))
        };
    }

    if (isTablet) {
        return {
            height: Number(customHeight.tablet) ? `${customHeight.tablet}px` : BANNER_HEIGHT_MOBILE,
            isCustomHeight: Boolean(Number(customHeight.tablet))
        };
    }

    return {
        height: Number(customHeight.desktop) ? `${customHeight.desktop}px` : BANNER_HEIGHT_DESKTOP,
        isCustomHeight: Boolean(Number(customHeight.desktop))
    };
};

export const useCalculateSliderHeight = ({
    customHeight,
    isTermsBlockNeeded
}: TCalculateBannerHeightProps): TCalculatedHeight => {
    const isMobile = useInMobile();
    const isTablet = useInTablet();
    const isDesktop = useInDesktop();

    const { height, isCustomHeight } = getBannerHeight({ customHeight, isMobile, isTablet });

    const getSliderHeight = () => {
        if (!isDesktop && isTermsBlockNeeded) {
            return `calc(${height} + ${isMobile ? TERMS_BLOCK_HEIGHT_MOBILE : TERMS_BLOCK_HEIGHT})`;
        }

        return height;
    };

    return { bannerHeight: height, sliderHeight: getSliderHeight(), isCustomHeight };
};
